/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/schedule_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdScheduleSettingsCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdScheduleSettingsProps,
  EmailIpWarmingAppGroupIdScheduleSettingsResult,
} from "./types";

export const postEmailIpWarmingAppGroupIdScheduleSettings = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdScheduleSettingsCacheKeys,
  (
    props: PostEmailIpWarmingAppGroupIdScheduleSettingsProps
  ): Promise<EmailIpWarmingAppGroupIdScheduleSettingsResult> => {
    // Extract the URL params (appGroupId, planId) from props and prepare the request body. A `planId`
    // updates that plan by id; without one the backend creates a new draft plan.
    const { appGroupId, planId, ...requestBody } = props;

    return fetch(
      `/email/ip_warming/${appGroupId}/schedule_settings${planId ? `/${planId}` : ""}`,
      "POST",
      requestBody,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
